import script from "./ScopePicker.vue?vue&type=script&setup=true&lang=js"
export * from "./ScopePicker.vue?vue&type=script&setup=true&lang=js"

import "./ScopePicker.vue?vue&type=style&index=0&id=87e1b840&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-87e1b840"]])

export default __exports__